import { withFormikInputWrapper } from '@perpay-web/components/higher-order/WithFormikInputWrapper/WithFormikInputWrapper';
import Checkbox from '@perpay-web/storefront/components/base/Checkbox/Checkbox';

const FormikCheckbox = withFormikInputWrapper(Checkbox);

export default FormikCheckbox;
